import { Element } from "@craftjs/core";
import Container from "components/general/Container";
import Section from "components/general/Section";
import { Box } from "components/ui";
import React from "react";
import { PageButton } from "./PageButton";
import { PageText } from "./PageText";

export const PageCallToActionTitle = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};
export const PageCallToActionDescription = ({ ...props }) => {
	return <Box>{props.children}</Box>;
};

export const PageCallToAction = () => {
	return (
		<Box bg="$primarydark" py={12}>
			<Container>
				{/* <div style={{ textAlign: "center" }}>
                    <Element id="call-to-action-button" is={PageButton} />
                </div> */}
				<Section gap={24} alignItems="center" bg="transparent">
					<Box>
						<Element id="call-to-action-title" data-cy="call-to-action-title-container" is={PageCallToActionTitle}>
							{/* <PageText text="Call to Action section" fontSize={28} data-cy="metrics-title-text" /> */}
							<PageText textAlign="center" fontSize={24} fontWeight="bold" text="Interested in working with us?" color="white" />
						</Element>
						<Element id="call-to-action-description" data-cy="call-to-action-description-container" is={PageCallToActionDescription}>
							<PageText
								textAlign="center"
								fontSize={16}
								text="We're always on the lookout for someone who can add value to our team. For more details on opportunities, click below
"
								color="white"
							/>
							{/* <PageText text="Lorem ipsum dolor sit amet consectetur adipisicing elit. Minima eum eos itaque alias fuga. Quae, labore!" fontSize={16} data-cy="metrics-description-text" /> */}
						</Element>
					</Box>
					<Box>
						<PageButton href="test" variant="primary" size="large" text="Join our team" />
					</Box>
				</Section>
			</Container>
		</Box>
		// <PageContainer {...props} background={"white"} padding={20}>
		// 	{/* <Element id="call-to-action-title" data-cy="call-to-action-title-container" is={PageCallToActionTitle}></Element>
		// 	<Element id="call-to-action-description" data-cy="call-to-action-description-container" is={PageCallToActionDescription}></Element>
		// 	<Element id="call-to-action-button" is={PageButton} /> */}
		// </PageContainer>
	);
};
